import { QUESTION } from "../../../api/Api";
import { useContext, useRef, useState } from "react";
import { handleMaxInputLines } from "../../HelpFullFunction";
import { CSSTransition } from "react-transition-group";
import BreakPoints from "../../../BreakPoints";
import Tags from "./Tags";
import { QuestionsPageContext } from "../../../context/QuestionsPageContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAskQuestion, useCloseField, useOpenField } from "../../../Store/MenuSlice";
import { useIsVerified, UserContext } from "../../../context/UserContext";
import { useAuth } from "../../../context/AuthContext";
import { authAxios } from "../../../Axios/createAxios";
export default function AskBox() {
  const [question, setQuestion] = useState("");
  const { userInfo } = useContext(UserContext);
  const queryClient = useQueryClient();
  const { selectedTag } = useContext(QuestionsPageContext);
  const askBoxRef = useRef(null);
  const { xLarge, xXLarge } = BreakPoints();
  const closeBox = useCloseField();
  const questionBoxState = useAskQuestion();
  const openField = useOpenField();
  const isVerified = useIsVerified();
  const { isAuth } = useAuth();
  const ask = async () => {
    try {
      const res = await authAxios.post(`/${QUESTION}`, { question: question, tag_id: selectedTag });
      return res;
    } catch (e) {
      throw e;
    }
  };
  const { mutate, isLoading } = useMutation({
    mutationFn: ask,
    onMutate: () => {},
    onSuccess: () => {
      setQuestion("");
      closeBox("askQuestion");
      setTimeout(() => {
        queryClient.invalidateQueries("questions");
      }, 100);
    },
    onError: (e) => console.log(e),
  });

  const onSub = (e) => {
    e.preventDefault();
    if (!isVerified) {
      openField("isVerified");
      return;
    }
    if (question.length < 25) return;
    if (!isAuth) return;

    if (isLoading) return;

    mutate();
  };

  return (
    <>
      <CSSTransition nodeRef={askBoxRef} in={questionBoxState} timeout={800} classNames="ask-box">
        <form ref={askBoxRef} onSubmit={onSub} className={`ask-box index-4`}>
          <textarea
            onInput={handleMaxInputLines}
            className="p-5"
            maxLength={150}
            rows="7"
            cols="34"
            name="ask"
            value={question}
            placeholder="You Have 150 letter to explain your stupid problem"
            onChange={(e) => setQuestion(e.target.value)}
          />
          <Tags />
          {xLarge || xXLarge ? (
            <button
              type="submit"
              className={`full-button `}
              style={question.length < 25 ? { opacity: "0.8", pointerEvents: "none" } : {}}
              disabled={question.length < 25}>
              send
            </button>
          ) : (
            <div className="d-flex justify-content-between align-items-center full-w ">
              <button type="button" onClick={() => closeBox("askQuestion")}>
                Back
              </button>
              <button
                style={question.length < 25 ? { opacity: "0.8", pointerEvents: "none" } : {}}
                disabled={question.length < 25}
                type="submit">
                send
              </button>
            </div>
          )}
        </form>
      </CSSTransition>
    </>
  );
}
